(() => {
  const name = 'header';

  App.common = App.common || {};

  App.common[name] = (() => {
    const $html = $('html');
    const $body = $('body');
    const $topMenu = $('.top-menu');
    const $topMenuWrapper = $('.top-menu-wrapper');
    const $topPageStick = $('[data-top-page-stick]');

    const $burgerMenu = $('.burger-menu');
    const $burgerBtn = $('.top-menu__btn--burger', $topMenu);
    const $closeBurgerMenuBtn = $('.burger-menu__btn--close', $burgerMenu);

    const $expandableSearch = $('[data-expandable-search]');
    const $expandableSearchForm = $('[data-expandable-search] form');
    const $expandableSearchInput = $('input', $expandableSearch);
    const $expandableSearchResults = $('[data-expandable-search-results]', $expandableSearch);
    const $expandableSearchToggleBtn = $('.top-menu__btn--search', $topMenu);
    const $expandableSearchReset = $('[data-expandable-search] .reset');
    const $expandableSearchBack = $('[data-expandable-search] .back');
    const $expandableSearchCloseButton = $('[data-search-close-button]');

    const $metamenu = $('.metamenu');
    const $metamenuToggleBtn = $('.top-menu__btn--metamenu', $topMenu);
    const defaultMetamenuPosition = $metamenu.length && $metamenu.position().top;

    let noScrollTimeout;
    let scrollPos = 0;
    let topPageStickHeight = 0;
    const recentlyClickedSearchAttribute = 'data-clicked-search';

    function allowDocumentScroll() {
      clearTimeout(noScrollTimeout);
      if ($html.hasClass('no-scroll')) {
        $html.removeClass('no-scroll');
        $body.removeClass('no-scroll');
        window.scrollTo(0, scrollPos); // Restore scroll position
      }
    }

    function preventDocumentScroll(timeout) {
      scrollPos = window.scrollY; // Save scroll position to restore when allowing scroll again
      noScrollTimeout = setTimeout(() => {
        $html.addClass('no-scroll');
        $body.addClass('no-scroll');
      }, timeout || 0);
    }

    function hideExpandableSearch() {
      if ($expandableSearch.attr('data-expandable-search-overlay') === 'visible') {
        // eslint-disable-next-line no-use-before-define
        clearSearchResult();
        $expandableSearch.attr({
          'data-expandable-search-overlay': 'hidden',
          'data-search-state': 'closed',
        });
        if (App.currentPage === 'LENS_START_PAGE') {
          $expandableSearch.attr({
            'data-search-module-state': 'closed',
          });
        }
        $topMenuWrapper.attr('data-search-state', 'closed');
        $expandableSearchToggleBtn.removeClass('hidden');
        if (!$expandableSearchInput.val()) {
          $expandableSearchReset.addClass('hide');
        }
        $expandableSearchInput.blur();
        allowDocumentScroll();
      }
    }

    function openBurgerMenu() {
      hideExpandableSearch();
      App.eventBus.trigger('burgermenu:opened');
      $burgerMenu.addClass('visible');
      preventDocumentScroll(150);
      $closeBurgerMenuBtn.addClass('open');
      $topMenuWrapper.attr('data-burger-menu-state', 'open');
    }

    function hideBurgerMenu() {
      if ($topMenuWrapper.attr('data-burger-menu-state') === 'open') {
        $burgerMenu.removeClass('visible');
        allowDocumentScroll();
        $closeBurgerMenuBtn.removeClass('open');
        $topMenuWrapper.attr('data-burger-menu-state', 'closed');
      }
    }

    function handleBurgerMenu() {
      $burgerBtn.on('click', openBurgerMenu);
      $closeBurgerMenuBtn.on('click', hideBurgerMenu);
    }

    function clickOutsideMetamenuHandler(e) {
      const $target = $(e.target);
      if (!$target.closest($metamenu).length && $metamenu.is(':visible')) {
        // eslint-disable-next-line no-use-before-define
        hideMetamenu();
      }
    }

    function hideMetamenu() {
      $topMenuWrapper.attr('data-metamenu-state', 'closed');

      document.removeEventListener('click', clickOutsideMetamenuHandler);
    }

    function openMetamenu() {
      if (!App.global.isMobile()) {
        App.global.recalculateElPosition($metamenu, defaultMetamenuPosition, $topPageStick);
      }
      $topMenuWrapper.attr('data-metamenu-state', 'open');

      hideExpandableSearch();
      App.eventBus.trigger('metamenu:opened');

      // Add event listener with delay to avoid race condition
      setTimeout(() => {
        document.addEventListener('click', clickOutsideMetamenuHandler);
      }, 100);
    }

    function clearSearchResult() {
      $expandableSearchResults.html('');
      $expandableSearch.removeAttr('data-has-results');
    }

    function fetchAutoSuggestions(searchTerm, targetElement) {
      $.get('/suggestions', { prefix: searchTerm }, (results) => {
        clearSearchResult(targetElement);
        if (results && results.length > 0) {
          $(JST['header-auto-suggest-results-fragment'](results))
            .appendTo(targetElement);
          $expandableSearch.attr('data-has-results', results.length);
        }
      });
    }

    function handleResetButton() {
      if ($expandableSearchInput.val().length > 0) {
        $expandableSearchReset.removeClass('hide');
      } else {
        $expandableSearchReset.addClass('hide');
      }
    }

    function openExpandableSearch() {
      App.eventBus.trigger('expandable-search:opening');
      scrollPos = window.scrollY;

      $expandableSearch.attr({
        'data-expandable-search-overlay': 'visible',
        'data-search-state': 'open',
      });
      if (App.currentPage === 'LENS_START_PAGE') {
        $expandableSearch.attr({
          'data-search-module-state': 'open',
        });
      }

      $topMenuWrapper.attr('data-search-state', 'open');
      $expandableSearchToggleBtn.addClass('hidden');
      preventDocumentScroll(150);
      window.scrollTo(0, 0);
      hideMetamenu();
      handleResetButton();
      $expandableSearchInput.focus();
      App.eventBus.trigger('expandable-search:opened');
      if ($expandableSearchInput.val().length > 0) {
        fetchAutoSuggestions($expandableSearchInput.val(), $expandableSearchResults);
      }
    }

    const setScrollingClasses = () => {
      $topMenu.addClass('scrolling');
      $expandableSearch.addClass('scrolling');
      $burgerMenu.addClass('scrolling');
      $('body').addClass('scrolling');
    };

    const removeScrollingClasses = () => {
      $topMenu.removeClass('scrolling');
      $expandableSearch.removeClass('scrolling');
      $burgerMenu.removeClass('scrolling');
      $('body').removeClass('scrolling');
    };

    function handleScrollingBehavior() {
      const scrollHeightThreshold = $topMenu.outerHeight();
      const deltaYThreshold = 15;
      let prevScrollTop = 0;

      const handlerFn = () => {
        const currentScrollTop = $(window).scrollTop();
        const scrollPosY = window.scrollY || window.pageYOffset;

        // Assume user is browsing the page when scrolled below this threshold
        if (scrollPosY > (topPageStickHeight || scrollHeightThreshold)) {
          setScrollingClasses();

          // Hide search field when scrolling fast enough
          if (Math.abs(currentScrollTop - prevScrollTop) > deltaYThreshold) {
            App.eventBus.trigger('page:scrolled');
          }
          prevScrollTop = currentScrollTop;
        } else {
          removeScrollingClasses();
        }
      };
      $(window).on('scroll touchmove', handlerFn);

      if ((window.scrollY || window.pageYOffset) > scrollHeightThreshold) {
        handlerFn();
      }
    }

    function countSearchResults() {
      return $expandableSearchResults.find('li').length;
    }

    function handleSwipeUp() {
      const el = document.getElementById('swipezone');
      App.components.swipeDetect.detect(el, (swipeDir) => {
        // swipedir contains either "none", "left", "right", "top", or "down"
        if (swipeDir === 'up' && countSearchResults() === 0) {
          hideExpandableSearch();
        }
      });
    }

    function handleSuggestionStepping(e, inputElement, resultsElement) {
      const resultCount = countSearchResults();
      if (resultCount === 0) {
        return;
      }
      // Find index of selected element
      const selectedElement = resultsElement.find('li.selected');
      selectedElement.removeClass('selected');
      let index = selectedElement.index();

      if (e.which === 38) {
        // Up arrow pressed
        if (index === -1) {
          index = resultCount - 1;
        } else {
          index -= 1;
        }

        if (index < 0) {
          index = resultCount - 1;
        }
      } else if (e.which === 40) {
        // Down arrow pressed
        if (index === -1) {
          index = 0;
        } else {
          index += 1;
        }

        if (index >= resultCount) {
          index = 0;
        }
      }

      const newSelection = resultsElement.find('li').eq(index);
      const value = newSelection.text();
      newSelection.addClass('selected');
      inputElement.val(value);
      App.eventBus.trigger('expandable-search:inputChanged', { value });
    }

    function handleKeyPress(inputElement, resultsElement) {
      inputElement.on('keydown', (e) => {
        switch (e.which) {
          case 13: // enter
            $expandableSearchForm.submit();
            break;
          case 27: // ESC
            hideExpandableSearch();
            break;
          case 8: // backspace
            if ($expandableSearchInput.val().length === 0) {
              hideExpandableSearch();
            }
            break;
          case 38: // up arrow
          case 40: // down arrow
            handleSuggestionStepping(e, inputElement, resultsElement);
            break;
          default:
            break;
        }
      });
    }

    function handleExpandableSearch() {
      handleKeyPress($expandableSearchInput, $expandableSearchResults);
      handleResetButton();

      $expandableSearchInput.on('focusin focus', (e) => {
        if ($expandableSearch.attr('data-expandable-search-overlay') === 'hidden') {
          openExpandableSearch();
        }

        e.preventDefault();
        return false;
      });

      $expandableSearchToggleBtn.on('click', () => {
        hideBurgerMenu();
        openExpandableSearch();
        $expandableSearch.attr(recentlyClickedSearchAttribute, 'true');

        setTimeout(() => {
          $expandableSearch.removeAttr(recentlyClickedSearchAttribute);
        }, 1000);
      });

      $expandableSearchInput.on('blur', () => {
        if ($expandableSearch.attr('data-expandable-search-overlay') === 'hidden') {
          allowDocumentScroll();
          // Delay showing toggle button to avoid showing it again when clicking on the hidden button in iOS.
          // This is because blur event is triggered before click so the button would be toggled on
          // before the click event handler is fired.
          setTimeout(() => {
            if ($expandableSearch.attr('data-expandable-search-overlay') === 'hidden') {
              $expandableSearchToggleBtn.removeClass('hidden');
            }
          }, 100);
        }
      });

      $expandableSearchInput.keyup(() => {
        handleResetButton();
      });

      $expandableSearchInput.on('input', () => {
        const value = $expandableSearchInput.val();
        if (value === '') {
          clearSearchResult();
        } else {
          fetchAutoSuggestions(value, $expandableSearchResults);
        }
        App.eventBus.trigger('expandable-search:inputChanged', { value });
      });

      $expandableSearchReset.on('click', (e) => {
        const value = '';
        e.stopPropagation();
        e.preventDefault();
        $expandableSearchInput.val(value);
        clearSearchResult();
        $expandableSearchInput.focus();
        handleResetButton();
        App.eventBus.trigger('expandable-search:inputChanged', { value });
      });

      $expandableSearchBack.on('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        hideExpandableSearch();
      });

      $expandableSearchCloseButton.on('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        hideExpandableSearch();
      });

      App.eventBus.on('quickcart:opened megamenu:opened', () => {
        hideExpandableSearch();
        hideBurgerMenu();
      });
      App.eventBus.on('expandable-search:show', openExpandableSearch);
    }

    function handleMetamenu() {
      $metamenuToggleBtn.on('click', () => {
        if ($topMenuWrapper.attr('data-metamenu-state') === 'open') {
          hideMetamenu();
        } else {
          openMetamenu();
        }
      });

      App.eventBus.on('page:scrolled megamenu:opened', () => {
        hideMetamenu();
        hideExpandableSearch();
      });

      if (!App.global.isMobile()) {
        $(window).on('scroll', () => {
          App.global.recalculateElPosition($metamenu, defaultMetamenuPosition, $topPageStick);
        });
      }

      let mouseLeaveTimeout;
      $metamenu
        .on('mouseleave', () => {
          mouseLeaveTimeout = setTimeout(hideMetamenu, 2000);
        })
        .on('mouseenter', () => {
          clearTimeout(mouseLeaveTimeout);
        });
    }

    function setTopPageStickHeight() {
      topPageStickHeight = $topPageStick.outerHeight();
    }

    function bindEventHandlers() {
      handleBurgerMenu();
      handleScrollingBehavior();
      handleSwipeUp();
      handleExpandableSearch();
      handleMetamenu();
      if ($topPageStick.length) {
        App.eventBus.on('top-page-stick:update-height', setTopPageStickHeight);
        App.eventBus.on('top-page-stick:clicked', (e, { topPageStickState }) => {
          $topMenuWrapper.attr('data-top-page-stick-state', topPageStickState);
          hideExpandableSearch();
        });
      }
    }

    const init = () => {
      bindEventHandlers();
    };

    return {
      init,
      preventDocumentScroll,
      allowDocumentScroll,
    };
  })();
})();
